import { Duration } from "luxon";

export const LEAVE_TIMEOUT_MS = Duration.fromObject({ seconds: 10 }).toMillis();
export const LEAVE_FALLBACK_TIMEOUT_MS = Duration.fromObject({
  seconds: 2,
}).toMillis();
export const MEDIA_TOGGLE_MAX_RETRIES = 2;
export const MEDIA_TOGGLE_RETRY_DELAY_MS = Duration.fromObject({
  seconds: 0.5,
}).toMillis();
export const AUDIO_RECOVERY_DELAY_MS = Duration.fromObject({
  seconds: 0.5,
}).toMillis();
export const ROOM_JOINED_TIMEOUT_MS = Duration.fromObject({
  seconds: 15,
}).toMillis();
export const DISCONNECTED_RECOVERY_TIMEOUT_MS = Duration.fromObject({
  seconds: 30,
}).toMillis();
export const RESTARTABLE_ROOM_LEFT_STATES = new Set([
  "ended",
  "failed",
  "left",
]);
export const TERMINAL_ROOM_LEFT_STATES = new Set([
  "kicked",
  "rejected",
  "stageLeft",
]);
